<template>
    <div id="new_operation">
        <div v-if="is_initialized">
            <table class="ui fixed table blue">
                <thead>
                    <tr>
                        <th class="right aligned">
                            <h3 class="ui header">
                                {{ $t('ui.page_titles.new_provider_operation') }}
                            </h3>
                        </th>
                        <th colspan="4">

                        </th>
                        <th>
                        </th>
                    </tr>
                </thead>
                <tbody class="ui form">
                    <tr>
                        <td class="right aligned">
                            {{ $t('models.attributes.operations.customer') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <div class="ui selection dropdown" v-dropdown ref="customer_identity">
                                <i class="dropdown icon"></i>
                                <div class="default text">{{ $t('ui.general.please_select') }}</div>
                                <div class="menu">
                                    <div
                                        class="item"
                                        v-for="customer in customers"
                                        @click="
                                        selected_customer = customer;
                                        operation.customer_identity = customer.identity;
                                        operation.contract_identity = customer.contracts[0].identity;">
                                            {{ customer.company_name }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="selected_customer" style="display: inline-block;">
                                <select v-dropdown v-model="operation.contract_identity">
                                    <option value>{{ $t('ui.general.please_select') }}</option>
                                    <option v-for="contract in selected_customer.contracts" :contract="contract" :value="contract.identity">{{ contract.name }}</option>
                                </select>
                            </div>
                            <button class="ui basic icon button"
                                @click="
                                    selected_customer = null;
                                    operation.customer_identity = null;
                                    operation.contract_identity = null;
                                    $($refs.customer_identity).dropdown('clear');
                                ">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td class="right aligned">
                            <!-- 分配站點 -->
                            {{ $t('models.attributes.operations.station') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <select class="ui dropdown" v-dropdown v-model="operation.station_identity" ref="station_identity">
                                <option value="">
                                    {{ $t('ui.general.please_select') }}
                                </option>
                                <option v-for="station in $store.state.provider.stations" :value="station.identity">{{ station.name }}</option>
                            </select>
                            <button class="ui basic icon button"
                                @click="
                                    operation.station_identity = null;
                                    $($refs.station_identity).dropdown('clear');
                                ">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td class="right aligned">
                            <!-- 分配人員 -->
                            {{ $t('models.attributes.operations.staffs') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <select class="ui dropdown" multiple="" v-dropdown v-model="operation.staff_identities" ref="staff_identities">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="staff in $store.state.provider.operations_module.staffs" :value="staff.identity">{{ staff.name }}</option>
                            </select>
                            <button class="ui basic icon button"
                                style="vertical-align: bottom;"
                                @click="
                                    operation.staff_identities = null;
                                    $($refs.staff_identities).dropdown('clear');
                                ">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td class="right aligned">
                            {{ $t('models.attributes.operations.your_note') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <textarea type="text"
                                v-model="operation.provider_note"
                                :placeholder="$t('models.attributes.operations.provider_note')">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td class="right aligned">
                            {{ $t('ui.general.operate') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <button class="ui basic positive button" @click.prevent="create">
                                {{ $t('ui.general.create') }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewOperation",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            operation: {},
            selected_customer: null,
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "new_operation") {
                this.init()
            }
        },
        'language' (value) {
            this.operation.provider_note = this.$t('ui.pages.operations.provider_note_value')
        },
    },
    computed: {
        language() {
            return this.$store.state.language
        },
        customers() {
            return this.$store.state.provider.customers
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.operation = {
                    provider_note: this.$t('ui.pages.operations.provider_note_value'),
                    staff_identities: [],
                    customer_identity: null,
                    contract_identity: null,
                }
                this.selected_customer = null
                this.errors = []
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        create() {
            if (
                (this.operation.customer_identity == null) || (
                    this.operation.customer_identity && this.operation.contract_identity
                )
            ) {
                this.is_processing = true
                this.errors = []
                var params = this.operation
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operations_create).parse(
                    {},
                    ""
                )

                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.is_processing = false
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.$t('models.operations')
                            })
                        )
                        this.$router.push({name: 'edit_provider_operation', params: {identity: response.data.operation.identity}})
                    } else {
                        this.$noty.error(
                            this.$t('ui.notifications.error.create__name', {
                                name: this.$t('models.operations')
                            })
                        )
                        this.is_processing = false
                    }
                })
                .catch(error => {
                    this.$noty.error(
                        this.$t('ui.notifications.error.create__name', {
                            name: this.$t('models.operations')
                        })
                    )
                    this.is_processing = false
                })
            } else {
                this.$noty.error(
                    this.$t('ui.pages.operations.helps.please_confirm_sender_and_contract_are_selected')
                )
            }
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
